import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps, withHandlers } from 'recompose';
import { extractAttributesFromProducts } from '../../helpers/attributes/extractAttributesFromProducts';
import ProductList from './ProductList';
import * as _ from 'lodash';

const  ǃssrCache = {};

const ToggleFavoriteMutation = gql`
  mutation toggleFavorite($variantId: String!) {
    toggleFavorite(variantId: $variantId)
  }
`;

const GetProductsQuery = gql`
  query($categoryId: String, $categoryByTag: String, $search: String, $language: String!, $country: String) {
    minimalProducts(categoryId: $categoryId, categoryByTag: $categoryByTag, search: $search, language: $language, country: $country) {
      id
      price
      status
      tags
      variants {
        id
        inStock
        definition
      }
      searchPriority
    }
    productTags {
      id
      title
      color
      slug
    }
  }
`;

export interface IProductListProps {
  language: string;
  country?: string;
  search: string | string[] | undefined;
  category: GQL.ICategory | undefined;
  categoryByTag?: string;
  setCurrentProductAvailabityWatchdogForm?: (
    product?: GQL.IProduct,
    variant?: GQL.IProductVariant,
  ) => void;
}

export default compose<{}, IProductListProps>(
  graphql<any, any>(ToggleFavoriteMutation, {
    name: 'toggleFavorite'
  }),
  graphql<IProductListProps, any>(GetProductsQuery, {
    name: 'products',
    options: props => ({
      variables: {
        search: props.search,
        categoryId: props.category ? props.category.id : undefined,
        categoryByTag: props.categoryByTag || undefined,
        language: props.language,
        country: props.country,
      }
    })
  }),
  withProps(({ products }: any) => {
    let ssrRetryCounter = 0;
    const retryTriesCountReached = (currentCount: number) => currentCount > 5;

    // Z nějakého důvodu se tento kód spouští dvakrát (něco někde volá refetch?) - po prvním načtení se načtou data v pořádku, při druhém načtení data chybí.
    // HACK: data z prvního volání uložit a při druhém načtení, když data produktů chybí, je použít
    if ((global as any).SSR) {
      if (!products.loading) {
        if (products.variables && products.variables.categoryId) {
          ǃssrCache[products.variables.categoryId] = {
            minimalProducts: products.minimalProducts,
            productTags: products.productTags,
          };
        }
      } else if (products.variables && products.variables.categoryId && ǃssrCache[products.variables.categoryId]) {
        products.loading = false;
        products.networkStatus = 7;
        products.minimalProducts = ǃssrCache[products.variables.categoryId].minimalProducts;
        products.productTags = ǃssrCache[products.variables.categoryId].productTags;
      }
    }

    const allProducts = !products.loading && Array.isArray(products.minimalProducts) ? products.minimalProducts : [];
    const allVariants = _.flatten(allProducts.map((p: any) => p.variants));
    const productTags = !products.loading && Array.isArray(products.productTags) ? products.productTags : [];

    if (!products.loading && products.minimalProducts === undefined && !products.error) {
      products.refetch();
    }

    if ((global as any).SSR && products.loading) {
      ssrRetryCounter++;
      if (!retryTriesCountReached(ssrRetryCounter)) {
        console.log('Apollo error, refetching products', ssrRetryCounter);
        // Refetch vypadá, že v SSR nefunguje
        products.refetch();
      }
    }
    if (retryTriesCountReached(ssrRetryCounter)) {
      console.log('Category products max refetch try reached', ssrRetryCounter);
    }
    console.log('Got products', Array.isArray(products.minimalProducts) && products.minimalProducts.length || '-');

    return {
      usedAttributesMap: extractAttributesFromProducts(allProducts),
      allVariants,
      allProducts,
      productTags,
      // in SSR, sometimes query ends with result { loading: true, networkStatus: 1, error: undefined } and no product detail is rendered
      // if that happens, make next attempt to load the page
      reloadPage: (global as any).SSR && products.loading && retryTriesCountReached(ssrRetryCounter),
    };
  }),
  withHandlers({}),
)(ProductList);



// WEBPACK FOOTER //
// ./src/components/ProductList/index.tsx